// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3LU9A","left":"InfoRow_left__DYpnu"};